import { render, staticRenderFns } from "./CourseListWrapper.vue?vue&type=template&id=3a953ad1&scoped=true&"
import script from "./CourseListWrapper.vue?vue&type=script&lang=js&"
export * from "./CourseListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CourseListWrapper.vue?vue&type=style&index=0&id=3a953ad1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a953ad1",
  null
  
)

export default component.exports